import {Account, Footer} from "../../components";

export function AccountPage() {
    return (
        <div>
            <Account/>
            <Footer/>
        </div>
    )
}